<span>{{DisplayValue}}</span>
<span> {{GetUnitDisplayUOM(DisplayUnit)}}</span>
&nbsp;

<!--<select [hidden]="!AllowConversion" [compareWith]='customCompareUnit' [(ngModel)]="DisplayUnit" (change)="UnitChanged($event)">
  @for(opt of AvailableUnits;track opt){
  <option [ngValue]="opt" [selected]="DisplayUnit.Unit == opt.Unit ? 'selected' : ''">{{GetUnitDisplayUOM(opt)}}</option>
  }
</select>-->
